module.exports = "/_next/static/images/ourPartnersEricssonLogo-edcdd134f684ea071a6d34c5f18a1004.webp";